/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { DeleteManpowerSettingCommand } from '../../models/delete-manpower-setting-command';
import { DeleteManpowerSettingCommandResult } from '../../models/delete-manpower-setting-command-result';

export interface ApiManpowerSettingDeleteManpowerSettingDelete$Params {
  
    /**
     * The command containing the ID of the manpower setting to delete.
     */
    body?: DeleteManpowerSettingCommand
}

export function apiManpowerSettingDeleteManpowerSettingDelete(http: HttpClient, rootUrl: string, params?: ApiManpowerSettingDeleteManpowerSettingDelete$Params, context?: HttpContext): Observable<StrictHttpResponse<DeleteManpowerSettingCommandResult>> {
  const rb = new RequestBuilder(rootUrl, apiManpowerSettingDeleteManpowerSettingDelete.PATH, 'delete');
  if (params) {
    rb.body(params.body, 'application/*+json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'text/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<DeleteManpowerSettingCommandResult>;
    })
  );
}

apiManpowerSettingDeleteManpowerSettingDelete.PATH = '/api/ManpowerSetting/DeleteManpowerSetting';
